// extracted by mini-css-extract-plugin
export default {"draft-filters-popup":"DraftFiltersPopup_draft-filters-popup__H-BQe","popup-header":"DraftFiltersPopup_popup-header__ym-g+"};